import LazyBuffer from "./lazy_buffer";

export default class AveragingLazyBuffer extends LazyBuffer {
  reducer(values) {
    return values.reduce((a, b) => a + b)/values.length;
  }
}


